export const IncidenciasActionTypes = {
  API_RESPONSE_SUCCESS: '@@incidencias/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@incidencias/API_RESPONSE_ERROR',

  GET_INCIDENCIA: '@@incidencias/GET_INCIDENCIA',
  LIST_INCIDENCIAS: '@@incidencias/LIST_INCIDENCIAS',
  ADD_INCIDENCIA: '@@incidencias/ADD_INCIDENCIA',
  UPDATE_INCIDENCIA: '@@incidencias/UPDATE_INCIDENCIA',
  DELETE_INCIDENCIA: '@@incidencias/DELETE_INCIDENCIA',

  RESET: '@@incidencias/RESET'
}
